export enum Tab {
  Home = "Home",
  About = "About",
  Contact = "Contact",
  Orders = "Orders",
  Podcast = "Podcast",
}
